/**
 * Billing and Charges Constants and Enumerations
 * Defines status values for sales closure billing and charge tracking
 *
 * @module constants/billingAndCharges
 */

// Billing Status
export const BILLING_STATUS = {
  BILLED: 'billed',
  UNBILLED: 'unbilled'
}

export const BILLING_STATUS_LABELS = {
  [BILLING_STATUS.BILLED]: 'Facturado',
  [BILLING_STATUS.UNBILLED]: 'No facturado'
}

export const BILLING_STATUS_COLORS = {
  [BILLING_STATUS.BILLED]: 'success',
  [BILLING_STATUS.UNBILLED]: 'danger'
}

// Charge Status
export const CHARGE_STATUS = {
  COLLECTED: 'collected',
  UNCOLLECTED: 'uncollected'
}

export const CHARGE_STATUS_LABELS = {
  [CHARGE_STATUS.COLLECTED]: 'Cobrado',
  [CHARGE_STATUS.UNCOLLECTED]: 'No cobrado'
}

export const CHARGE_STATUS_COLORS = {
  [CHARGE_STATUS.COLLECTED]: 'success',
  [CHARGE_STATUS.UNCOLLECTED]: 'danger'
}

// Billing Mode
export const BILLING_MODE_LABELS = {
  full_campaign_start_100: 'Inicio 100%',
  campaign_start_partial_months: 'Inicio parcial',
  full_campaign_end: 'Fin campaña',
  monthly_closure: 'Cierre mensual'
}

// Payment Mode
export const PAYMENT_MODE_LABELS = {
  always_pay_full_po: 'ODC 100%',
  pay_by_consumption: 'Por consumo'
}

// Agency Commission Mode
export const AGENCY_COMMISSION_MODE_LABELS = {
  platform_invoice_payment: 'Factura LatinAd',
  platform_invoice: 'Solo factura',
  no_invoice: 'Sin factura'
}

// Campaign Type
export const CAMPAIGN_TYPE_LABELS = {
  programmatic: 'Programática',
  exchange: 'Exchange',
  dsp: 'DSP'
}

// Query Filters - Status para API
export const BILLING_STATUS_FILTER_OPTIONS = [
  { value: 'billed', text: 'Facturado' },
  { value: 'unbilled', text: 'No facturado' },
  { value: '', text: 'Todos' }
]

export const CHARGE_STATUS_FILTER_OPTIONS = [
  { value: 'collected', text: 'Cobrado' },
  { value: 'uncollected', text: 'No cobrado' },
  { value: '', text: 'Todos' }
]
